import SidebarNavigation from '../SidebarNavigation';
import { NavigationSection } from '../types';

interface FormSidebarProps {
  navigationSections: NavigationSection[];
  progressPercentage: number;
  lastSaved: string | null | undefined;
  isSaving: boolean;
  isProgressStale: boolean;
  saveError?: string | null;
  isSubmitting?: boolean;
}

/**
 * Sidebar navigation component for the dynamic form
 * Displays progress, navigation sections, and save status
 */
export const FormSidebar = ({
  navigationSections,
  progressPercentage,
  lastSaved,
  isSaving,
  isProgressStale,
  saveError,
  isSubmitting,
}: FormSidebarProps) => {
  return (
    <div className="sidebar hidden lg:block fixed left-0 top-20 w-80 h-[calc(100vh-5rem)]">
      <div className="bg-white shadow-lg border-r border-gray-200 h-full">
        <SidebarNavigation
          sections={navigationSections}
          progressPercentage={progressPercentage}
          lastSaved={lastSaved}
          isSaving={isSaving}
          isProgressStale={isProgressStale}
          saveError={saveError}
          isSubmitting={isSubmitting}
        />
      </div>
    </div>
  );
};
